"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecordsService = void 0;
var _records = require("../controllers/records.controller");
var RecordsService = {
  bulk: {
    deleteHard: _records.config.bulk + "/delete/hard",
    deleteSoft: _records.config.bulk + "/delete/soft",
    deleteSoftRestore: _records.config.bulk + "/delete/soft/restore",
    link: _records.config.bulk + "/link"
  },
  records: {
    read: _records.config.records,
    deleteHard: _records.config.records + "/delete/hard",
    deleteSoft: _records.config.records + "/delete/soft",
    deleteSoftRestore: _records.config.records + "/delete/soft/restore",
    list: _records.config.records + "/list",
    listSoftDeleted: _records.config.records + "/list/soft/deleted",
    uniqueReferenceNo: _records.config.records + "/unique/reference-no",
    uniqueUrlExtension: _records.config.records + "/unique/url-extension",
    exists: _records.config.records + "/exists",
    copySiteUrl: _records.config.records + "/copy-url/site",
    copyReportUrl: _records.config.records + "/copy-url/report",
    notifyUnlockStatus: _records.config.baseRecord + "/editor-notification"
  },
  donor: {
    email: _records.config.donors + "/email",
    passcode: _records.config.donors + "/passcode",
    passcodeMagicLink: _records.config.donors + "/passcode/magic-link"
  },
  fund: {
    find: _records.config.funds,
    link: _records.config.funds + "/link",
    linkSingle: _records.config.funds + "/link/single",
    list: _records.config.funds + "/list/records",
    unlink: _records.config.funds + "/unlink/all",
    unlinkSingle: _records.config.funds + "/unlink/single"
  },
  recordsEmailBug: {
    downloadSite: _records.config.recordsEmailBug + "/site",
    downloadReport: _records.config.recordsEmailBug + "/report"
  },
  magiclink: {
    site: _records.config.records + "/magic-link/site",
    report: _records.config.records + "/magic-link/report",
    passcode: _records.config.records + "/donors/passcode",
    siteExport: _records.config.baseExport + "/export/site/distribution"
  }
};
exports.RecordsService = RecordsService;